<template lang="html">
  <div class="section-seperator" :class="separatorClasses">
    <div class="section-placeholder before">
      <span>&uarr;</span>
      The section before
      <span>&uarr;</span>
    </div>

    <div :is="type"></div>

    <div class="section-placeholder after">
      <span>&darr;</span>
      The section after
      <span>&darr;</span>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import Slant from '@/components/Previewers/Separators/Slant'
import Clouds from '@/components/Previewers/Separators/Clouds'
import Hills from '@/components/Previewers/Separators/Hills'
import Triangle from '@/components/Previewers/Separators/Triangle'
import Waves from '@/components/Previewers/Separators/Waves'

export default {
  name: 'SectionSeparator',

  mixins: [parseComponent],

  components: {
    Slant,
    Clouds,
    Hills,
    Triangle,
    Waves
  },

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    type() {
      return this.parse(this.currentListItem).style
    },

    separatorClasses() {
      let flipY = this.parse(this.currentListItem).flip_vertical
      let flipX = this.parse(this.currentListItem).flip_horizontal
      let flipBoth = flipY && flipX

      return [
        'section-separator',
        {'flip-vertical': flipY},
        {'flip-horizontal': flipX},
        {'flip-both': flipBoth}
      ]
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'

.section-seperator
  background: #205766
  border-radius: 5px
  overflow: hidden

  svg
    width: 100%
    height: 100px

  &.flip-vertical
    svg
      transform: scaleY(-1)

    .section-placeholder
      &.before
        background: rgba(255, 255, 255, 0.6)

      &.after
        background: rgba(255, 255, 255, 0.5)

  &.flip-horizontal
    transform: scaleX(-1)

    .section-placeholder
      transform: scaleX(-1)

  &.flip-both
    transform: scaleX(-1, -1)

  .top-svg
    fill: rgba(255, 255, 255, 0.5)

  .bottom-svg
    fill: rgba(255, 255, 255, 0.6)

  .section-placeholder
    text-align: center
    padding: $gap-small
    color: rgba(0, 0, 0, 0.5)

    span
      font-weight: bold
      margin: 0 3px
      font-size: 16px

    &.before
      background: rgba(255, 255, 255, 0.5)
      padding-bottom: 100px

    &.after
      background: rgba(255, 255, 255, 0.6)
      padding-top: 100px
      margin-top: -4px
</style>
